<template>
  <div class="bg-grey-lightest h-screen">
    <the-navbar/>
    <div class>
      <child/>
    </div>

    <footer class="bg-pink-darker">
      <div
        class="container p-6 py-10 flex flex-col lg:flex-row justify-between text-xl mx-auto text-white tracking-wide"
      >
        <span>Reach out. Inspire. Support. Empower.</span>
        
        <span class="text-xl">Copyright RISE Women Network &copy;2019</span>
      </div>
    </footer>
  </div>
</template>

<script>
import TheNavbar from "@/components/TheNavbar";
import TheSidebar from "@/components/TheSidebar";
export default {
  name: "DefaultLayout",

  components: {
    TheSidebar,
    TheNavbar
  }
};
</script>



// WEBPACK FOOTER //
// src/layouts/default.vue